import {useEffect, useState} from 'react';

import {InputText} from 'primereact/inputtext';
import {Dropdown} from 'primereact/dropdown';
import {TabView, TabPanel} from 'primereact/tabview';
import {Button} from 'primereact/button';

import {TypeInvoiceService} from '../../../service/invoice/TypeInvoiceService';
import {InvoiceSettingDefaultService} from './InvoiceSettingDefaultService';

import {Settings} from './item/Settings';
import {TenantInvoiceSettingMasterService} from './TenantInvoiceSettingMasterService';

import {ToastService} from '../../../AppToast';
import {useTranslation} from '../../../shared/language';

export const Create = () => {
  const {t} = useTranslation();

  const [submitting, setSubmitting] = useState(false);
  const [name, setName] = useState('');
  const [typeInvoiceId, setTypeInvoiceId] = useState('');
  const [invoiceTypes, setInvoiceTypes] = useState([]);
  const [invoiceGroups, setInvoiceGroups] = useState([]);
  const [invoiceGroupSettings, setInvoiceGroupSettings] = useState({});
  const [allSettings, setAllSettings] = useState([]);

  useEffect(() => {
    TypeInvoiceService.getList({}).then(({items}) => {
      if (items) {
        const _invoiceTypes = [];
        items.forEach((item) => {
          _invoiceTypes.push({value: item.id, label: item.name});
        });
        setInvoiceTypes(_invoiceTypes);
        setTypeInvoiceId(_invoiceTypes[0].value);
      }
    });
    InvoiceSettingDefaultService.getGroupTypeCode().then((data) => {
      const _invoiceGroups = [];
      Object.keys(data).forEach(key => {
        _invoiceGroups.push({value: key, label: data[key]});
      });
      setInvoiceGroups(_invoiceGroups);
    });
  }, []);

  useEffect(() => {
    if (invoiceGroups.length && typeInvoiceId) {
      const _invoiceGroupSettings = {}, _allSettings = [], load = [];
      invoiceGroups.forEach(group => {
        load.push(new Promise<void>((resolve) => {
          InvoiceSettingDefaultService.getList({GroupTypeCode: group.value, typeInvoiceId, maxResultCount: 1000}).then(({items}) => {
            _invoiceGroupSettings[group.value] = items;
            _allSettings.push(...items);
            resolve();
          });
        }));
      });
      Promise.all(load).then(() => {
        setInvoiceGroupSettings(_invoiceGroupSettings);
        setAllSettings(_allSettings);
      });
    }
  }, [invoiceGroups, typeInvoiceId]);

  const sortItems = (group) => {
    const _invoiceGroupSettings: any = {...invoiceGroupSettings};
    const df = 1000 * 1000;
    _invoiceGroupSettings[group].sort((a, b) => {
      return (a.orders || df) - (b.orders || df);
    });
    setInvoiceGroupSettings(_invoiceGroupSettings);
  }

  const setItems = (group, items) => {
    const _invoiceGroupSettings: any = {...invoiceGroupSettings};
    _invoiceGroupSettings[group] = items;
    setInvoiceGroupSettings(_invoiceGroupSettings);
  }

  const back = () => {
    window.location.hash = '/he-thong/cau-hinh-hoa-don';
  }

  const handleSubmit = () => {
    if (!submitting) {
      if (name && name.trim()) {
        if (typeInvoiceId) {
          setSubmitting(true);

          const invoiceSettings = [];
          Object.keys(invoiceGroupSettings).forEach((key) => {
            invoiceSettings.push(...invoiceGroupSettings[key]);
          });

          TenantInvoiceSettingMasterService.create({
            typeInvoiceId,
            name,
            invoiceSettings: invoiceSettings
          }).then(() => {
            ToastService.success();
            window.location.hash = '/he-thong/cau-hinh-hoa-don';
          }).catch(() => {
            setSubmitting(false);
          });
        } else {
          ToastService.error(t('system.invoiceTypeRequired'));
        }
      } else {
        ToastService.error(t('system.configCodeRequired'));
      }
    }
  }

  return (
    <div className="mt-1 pl-3 pr-3 pt-2">
      <div className="p-fluid formgrid grid">
        <div className="field col-12 md:col-6">
          <label htmlFor="name">{t('system.configCode')}</label>
          <InputText id="name" value={name} keyfilter="alphanum" onChange={e => setName(e.target.value.toUpperCase())}/>
        </div>
        <div className="field col-12 md:col-6">
          <label htmlFor="typeInvoiceId">{t('system.invoiceType')}</label>
          <Dropdown id="typeInvoiceId" value={typeInvoiceId} options={invoiceTypes} onChange={e => setTypeInvoiceId(e.value)}/>
        </div>
      </div>

      <TabView>
        {invoiceGroups.map((group, index) => {
          return (
            <TabPanel key={index} header={group.label}>
              <Settings items={invoiceGroupSettings[group.value]} setItems={setItems} invoiceGroups={invoiceGroups} allSettings={allSettings}
                        group={group.value} sortItems={sortItems}/>
            </TabPanel>
          )
        })}
      </TabView>

      <div className="flex justify-content-center mt-3">
        <Button label={t('system.exit')} icon="pi pi-times" onClick={back} className="p-button-outlined p-button-secondary p-button-sm mr-2"/>
        <Button label={t('common.save')} icon="pi pi-check" onClick={handleSubmit} loading={submitting} className="p-button-sm"/>
      </div>
    </div>
  );
}
